var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { memoize } from '../../../../utils/mobx/decorators/memoize';
import { round } from '../../../../utils/helper/lodash_replacements';
import { APIData } from '../../../api/APIData';
export class LocationProgress {
    parent;
    constructor(parent) {
        this.parent = parent;
    }
    get location() {
        return this.parent;
    }
    get progressQuery() {
        return new APIData({
            route: `/api/personal/${this.location.type}/progress/${this.location.pathURI}`,
            defaultValue: {
                questions_total: 0,
                questions_total_app: 0,
                questions: 0,
                questions_app: 0,
                questions_passed: 0,
            },
        });
    }
    get progressInfo() {
        return this.progressQuery.streamedRef;
    }
    get progressPercent() {
        if (!this.progressInfo)
            return 0;
        return round((100 * this.progressInfo.questions_passed) / this.progressInfo.questions, 1);
    }
    get remainingQuestionsCount() {
        if (!this.progressInfo)
            return 0;
        return this.progressInfo.questions - this.progressInfo.questions_passed;
    }
}
__decorate([
    memoize
], LocationProgress.prototype, "progressQuery", null);
